export function toHHMMSS(setup) {
  if (setup.expanded.rounds.length === 0) {
    let sets = setup.sets;
    let work = setup.work;
    let rest = setup.rest;
    let totalSec = Number(work.min) * 60 + Number(work.sec);
    if (rest !== undefined) {
      let restSec = Number(rest.min) * 60 + Number(rest.sec);
      totalSec += restSec;
    }
    if (sets !== undefined) {
      totalSec *= sets;
    }
    return getTime(totalSec);
  } else {
    let totalSec = 0;
    for (let round of setup.expanded.rounds) {
      let work = round.work;
      let rest = round.rest;
      totalSec += Number(work.min) * 60 + Number(work.sec);
      if (rest !== undefined) {
        let restSec = Number(rest.min) * 60 + Number(rest.sec);
        totalSec += restSec;
      }
    }
    return getTime(totalSec);
  }
  return "00" + ":" + "00" + ":" + "00";
}

export function getTime(sec) {
  let sec_num = parseInt(sec, 10); // don't forget the second param
  let hours = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - hours * 3600) / 60);
  let seconds = sec_num - hours * 3600 - minutes * 60;
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  if (hours === "00") {
    return minutes + ":" + seconds;
  } else {
    return hours + ":" + minutes + ":" + seconds;
  }
}

export function getTimers(setup) {
  let timers = [];
  if (setup.type === "rft" || setup.expanded.rounds.length === 0) {
    let prepare = setup.prepare;
    let prepareTotalSec = Number(prepare.min) * 60 + Number(prepare.sec);
    let prepareTimer = {
      isWorkout: false,
      name: "prepare",
      sec: prepareTotalSec,
    };
    if (prepareTotalSec !== 0) {
      timers.push(prepareTimer);
    }
    if (!setup.sets && setup.work) {
      let work = setup.work;
      let workTotalSec = Number(work.min) * 60 + Number(work.sec);
      let workTimer = {
        isWorkout: true,
        name: "work",
        sec: workTotalSec,
      };
      if (workTotalSec !== 0) {
        timers.push(workTimer);
      }
    }
    for (let i = 0; i < setup.sets; i++) {
      let work = setup.work;
      let rest = setup.rest;
      let workTotalSec = Number(work.min) * 60 + Number(work.sec);
      let workTimer = {
        isWorkout: true,
        name: `round ${i + 1}`,
        sec: workTotalSec,
      };
      if (workTotalSec !== 0) {
        timers.push(workTimer);
      }
      if (rest !== undefined) {
        let restTotalSec = Number(rest.min) * 60 + Number(rest.sec);
        let restTimer = {
          isWorkout: false,
          name: "rest",
          sec: restTotalSec,
        };
        if (restTotalSec !== 0) {
          timers.push(restTimer);
        }
      }
    }
    if (setup.cooldown) {
      let cooldown = setup.cooldown;
      let cooldownTotalSec = Number(cooldown.min) * 60 + Number(cooldown.sec);
      let cooldownTimer = {
        isWorkout: false,
        name: "cooldown",
        sec: cooldownTotalSec,
      };
      if (cooldownTotalSec !== 0) {
        timers.push(cooldownTimer);
      }
    }
  } else {
    let prepare = setup.expanded.prepare;
    let prepareTotalSec = Number(prepare.min) * 60 + Number(prepare.sec);
    let prepareTimer = {
      isWorkout: false,
      name: "prepare",
      sec: prepareTotalSec,
    };
    if (prepareTotalSec !== 0) {
      timers.push(prepareTimer);
    }
    setup.expanded.rounds.forEach(function (round, i) {
      let work = round.work;
      let rest = round.rest;
      let workTotalSec = Number(work.min) * 60 + Number(work.sec);
      let workTimer = {
        isWorkout: true,
        name: setup.type === "amrap" ? "work" : round.name || `round ${i + 1}`,
        sec: workTotalSec,
      };
      if (workTotalSec !== 0) {
        timers.push(workTimer);
      }
      if (rest !== undefined) {
        let restTotalSec = Number(rest.min) * 60 + Number(rest.sec);
        let restTimer = {
          isWorkout: false,
          name: "rest",
          sec: restTotalSec,
        };
        if (restTotalSec !== 0) {
          timers.push(restTimer);
        }
      }
    });
    let cooldown = setup.expanded.cooldown;
    let cooldownTotalSec = Number(cooldown.min) * 60 + Number(cooldown.sec);
    let cooldownTimer = {
      isWorkout: false,
      name: "cooldown",
      sec: cooldownTotalSec,
    };
    if (cooldownTotalSec !== 0) {
      timers.push(cooldownTimer);
    }
  }
  return timers;
}

export function getTimeSetup(sec) {
  let sec_num = parseInt(sec, 10); // don't forget the second param
  let minutes = Math.floor(sec_num / 60);
  let seconds = sec_num - minutes * 60;
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return {
    min: minutes,
    sec: seconds,
  };
}

export function getShareLink(baseUrl, setup) {
  if (baseUrl) {
    const url = new URL(baseUrl);

    switch (setup.type) {
      case "tabata":
        url.searchParams.append("t", "tabata");
        if (setup.expanded.rounds.length === 0) {
          url.searchParams.append("s", setup.sets);
          url.searchParams.append("w", getSecFromTimeString(setup.work));
          url.searchParams.append("r", getSecFromTimeString(setup.rest));
        } else {
          url.searchParams.append(
            "p",
            getSecFromTimeString(setup.expanded.prepare)
          );
          url.searchParams.append(
            "c",
            getSecFromTimeString(setup.expanded.cooldown)
          );
          url.searchParams.append("n", setup.expanded.name);
          url.searchParams.append("d", setup.expanded.description);
          setup.expanded.rounds.forEach(function (round, i) {
            url.searchParams.append(
              "r",
              `${round.name};${getSecFromTimeString(
                round.work
              )};${getSecFromTimeString(round.rest)}`
            );
          });
        }
        break;
      case "emom":
        url.searchParams.append("t", "emom");
        if (setup.expanded.rounds.length === 0) {
          url.searchParams.append("s", setup.sets);
          url.searchParams.append("w", getSecFromTimeString(setup.work));
        } else {
          url.searchParams.append(
            "p",
            getSecFromTimeString(setup.expanded.prepare)
          );
          url.searchParams.append(
            "c",
            getSecFromTimeString(setup.expanded.cooldown)
          );
          url.searchParams.append("n", setup.expanded.name);
          url.searchParams.append("d", setup.expanded.description);
          setup.expanded.rounds.forEach(function (round, i) {
            url.searchParams.append(
              "r",
              `${round.name};${getSecFromTimeString(round.work)}`
            );
          });
        }
        break;
      case "amrap":
        url.searchParams.append("t", "amrap");
        if (setup.expanded.rounds.length === 0) {
          url.searchParams.append("w", getSecFromTimeString(setup.work));
        } else {
          url.searchParams.append(
            "p",
            getSecFromTimeString(setup.expanded.prepare)
          );
          url.searchParams.append(
            "c",
            getSecFromTimeString(setup.expanded.cooldown)
          );
          url.searchParams.append("n", setup.expanded.name);
          setup.expanded.rounds.forEach(function (round, i) {
            url.searchParams.append("r", getSecFromTimeString(round.work));
            url.searchParams.append("d", round.description);
          });
        }
        break;
      case "rft":
        url.searchParams.append("t", "rft");
        if (setup.isExpanded) {
          url.searchParams.append("p", getSecFromTimeString(setup.prepare));
          url.searchParams.append("n", setup.name);
          url.searchParams.append("d", setup.description);
        }
        break;
    }
    return url;
  }
}

export function getSaveLink(id, baseUrl, setup) {
  let url = getShareLink(baseUrl, setup);
  if (url) {
    url.searchParams.append("id", id);
    return url;
  }
}

export function getSecFromTimeString(time) {
  return Number(time.min) * 60 + Number(time.sec);
}

export function getWorkoutName(setup, defaultName) {
  const d = new Date();
  const dateString =
    ("0" + d.getDate()).slice(-2) +
    "-" +
    ("0" + (d.getMonth() + 1)).slice(-2) +
    "-" +
    d.getFullYear() +
    " " +
    ("0" + d.getHours()).slice(-2) +
    ":" +
    ("0" + d.getMinutes()).slice(-2);
  let name = "My Workout " + dateString;

  switch (setup.type) {
    case "tabata":
      if (setup.expanded.rounds.length !== 0) {
        name = setup.expanded.name || defaultName || "Tabata " + dateString;
      } else {
        name = defaultName || "Tabata " + dateString;
      }
      break;
    case "emom":
      if (setup.expanded.rounds.length !== 0) {
        name = setup.expanded.name || defaultName || "EMOM " + dateString;
      } else {
        name = defaultName || "EMOM " + dateString;
      }
      break;
    case "amrap":
      if (setup.expanded.rounds.length !== 0) {
        name = setup.expanded.name || defaultName || "AMRAP " + dateString;
      } else {
        name = defaultName || "AMRAP " + dateString;
      }
      break;
    case "rft":
      if (setup.isExpanded) {
        name = setup.name || defaultName || "RFT " + dateString;
      } else {
        name = defaultName || "RFT " + dateString;
      }
      break;
  }
  return name;
}

export function id() {
  return "_" + Math.random().toString(36).substr(2, 9);
}
